module.exports = __webpack_public_path__ + "media/images/bnr_referral_s_sp-6dd3c10c987d24add8c5e485d9d03d7a.jpg";